<template>
  <div class="main" :class="{ 'main-hide-text': shrink }">
    <div
      class="sidebar-menu-con"
      :style="{
        background: menuTheme == 'light' ? '#fff' : '#303954',
        width: shrink ? '60px' : '180px',
        overflow: shrink ? 'visible' : 'auto',
        'box-shadow': 'none',
      }"
    >
      <scroll-bar ref="scrollBar">
        <shrinkable-menu
          :shrink="shrink"
          @on-change="handleSubmenuChange"
          :theme="menuTheme"
          :before-push="beforePush"
          :open-names="openedSubmenuArr"
          :menu-list="menuList"
        >
          <div slot="top" class="logo-con">
            <img
              v-show="!shrink"
              :src="logo"
              class="logo"
              key="max-logo"
              @click="goToIndex()"
            />
            <div style="margin-left: 5px">
              <img
                v-show="shrink"
                :src="minlogo"
                class="logo_min"
                key="min-logo"
                @click="goToIndex()"
              />
            </div>
          </div>
        </shrinkable-menu>
      </scroll-bar>
    </div>

    <div
      class="main-header-con"
      :style="{
        paddingLeft: shrink ? '60px' : '180px',
        height: 'auto',
        'box-shadow': 'none',
      }"
    >
      <div class="main-header" style="box-shadow: none">
        <div class="navicon-con">
          <Button
            :style="{
              transform: 'rotateZ(' + (this.shrink ? '-180' : '0') + 'deg)',
            }"
            type="text"
            @click="toggleClick"
          >
            <Icon type="md-options" size="24" style="margin-top: 2px"></Icon>
            <!-- <Icon type="navicon" size="30"></Icon> -->
          </Button>
        </div>
        <div class="navicon-con">
          <Button type="text" @click="backClick">
            <Icon
              type="md-arrow-round-back"
              size="24"
              style="margin-top: 2px; color: #666"
            ></Icon>
            <!--             <Icon type="ios-arrow-thin-left" size="30"></Icon>-->
          </Button>
        </div>

        <div class="header-middle-con">
          <div class="main-breadcrumb">
            <span
              style="color: #13171f; font-size: 20px"
              v-if="!this.schoolId && !this.syfId && menuList[0]"
            >
              <!-- 智慧工作好伙伴 -->
              {{ menuList[0].title }}</span
            >
            <span
              style="color: #13171f; font-size: 20px"
              v-if="this.schoolId"
              >{{ "高校智慧服务平台" }}</span
            >
            <span style="color: #13171f; font-size: 20px" v-if="this.syfId">{{
              "浙江大学医学院附属邵逸夫医院"
            }}</span>
          </div>
        </div>
        <div class="header-avator-con">
          <div class="user-dropdown-menu-con" style="right: 15px">
            <Row
              type="flex"
              justify="start"
              align="middle"
              style="padding-right: 0px"
            >
              <div class="message_notification" @click="onMessageTo()">
                <el-badge
                  :value="messageNum"
                  :hidden="messageNum == 0 ? true : false"
                  class="message_notification_item"
                  id="Num"
                >
                  <img src="../assets/img/message_icon.png" alt="" />
                </el-badge>
              </div>
              <Poptip
                confirm
                title="是否清空未读通知?"
                v-if="messageNum == 0 ? false : true"
                @on-ok="ok"
                @on-cancel="cancel"
                ok-text="是"
                cancel-text="否"
              >
                <div class="broom">
                  <img src="../assets/img/broom.png" alt="" />
                </div>
              </Poptip>
              <span v-if="isSystem" class="main-user-name1">{{
                "您好！" + userName
              }}</span>
              <span v-if="!isSystem" class="main-user-name3">{{
                "您好！" + userName
              }}</span>
              <br /><br />
              <!-- <span class="main-user-name2">
                {{
                customerName + "\ " + deskName + "\ " + address
              }}
              </span> -->
              <Dropdown
                v-if="!isSystem"
                transfer
                trigger="hover"
                transfer-class-name="dropdown-class"
                @on-click="handleClickUserDropdown"
              >
                <a href="javascript:void(0)">
                  <Icon
                    size="20"
                    style="margin: 0 5px; margin-top: 10px"
                    type="ios-arrow-down"
                  ></Icon>
                </a>
                <DropdownMenu slot="list">
                  <template v-if="shopDrop.length > 0">
                    <DropdownItem
                      v-for="(item, index) in shopDrop"
                      :key="index"
                      :name="item.value"
                    >
                      <Badge
                        :color="item.value == shopId ? 'blue' : '#fff'"
                        :text="item.name"
                      />
                    </DropdownItem>
                  </template>
                  <DropdownItem name="userInfo" divided>个人中心</DropdownItem>
                  <DropdownItem name="logout" divided>退出登录</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <full-screen
                v-model="isFullScreen"
                style="float: left; margin-right: 5px; margin-top: 5px"
                @on-change="fullscreenChange"
              ></full-screen>
              <Avatar
                :src="avatorPath"
                style="
                  background: #fff;
                  margin-left: 10px;
                  width: 40px;
                  height: 40px;
                  line-height: 40px;
                  border-radius: 20px;
                  margin-top: 5px;
                "
              ></Avatar>
            </Row>
          </div>
        </div>
      </div>
    </div>
    <div
      id="box-body"
      class="single-page-con"
      :style="{ left: shrink ? '60px' : '180px', top: '70px' }"
    >
      <div class="single-page">
        <Card dis-hover shadow style="position: relative; box-shadow: none">
          <Spin fix v-if="cardLoading">
            <Icon
              type="ios-loading"
              size="18"
              class="card-spin-icon-load"
            ></Icon>
            <div>加载中</div>
          </Spin>
          <router-view></router-view>
        </Card>
      </div>
    </div>
  </div>
</template>
<script>
import * as mainComponents from "./components/main";
import Cookies from "js-cookie";
import config from "@/../config";
import Calling from "./callcenter/calling.vue";
import logo_main from "../assets/img/login_main.png";
import { mapState } from "vuex";

export default {
  components: mainComponents,
  data() {
    return {
      deskName: "",
      address: "",
      schoolIf: false,
      customerName: "",
      env_type: config.env_type,
      titles: config.title,
      logo: logo_main,
      minlogo: config.minlogo,
      shrink: false,
      isFullScreen: false,
      openedSubmenuArr: this.$store.state.app.openedSubmenuArr,
      shopDrop: [],
      isCalling: false,
      isSystem: true,
      messageNum: window.localStorage.getItem("messageNum"),
    };
  },

  async created() {
    const storedNum = localStorage.getItem("messageNum");
    this.$store.commit(
      "MessageNum/setMessageNum",
      storedNum ? parseInt(storedNum, 10) : 0
    ); // 初始化状态
    await this.getMessageNum(); // 确保 API 调用
    this.isSystem =
      window.localStorage.getItem("pcFun") == 2 ||
      window.localStorage.getItem("pcFun") == 5 ||
      false;
    this.getLogin();
    let MaintainerToken = global.$utils.data.get("", "token");
    if (
      !MaintainerToken &&
      window.localStorage.getItem("token") == '{"data":""}'
    ) {
      return;
    } else {
      this.getCustomerInfo();
    }

    // 显示打开的页面的列表
    if (
      window.localStorage.getItem("mainType") != "2" &&
      window.localStorage.getItem("mainType") != "3" &&
      !$utils.data.get("UserInfo", "Calling")
    ) {
      $utils.data.set("UserInfo", "Calling", true);
      let _that = this;
      this.$bus.$on("zuoxi", async function () {
        if (
          _that.isCalling ||
          $utils.data.get("auth", "auths") === [] ||
          !$utils.data.get("auth", "auths")
        ) {
          return;
        }
        try {
          _that.isCalling = true;
          await _that.getUserCall();
        } finally {
          _that.isCalling = false;
        }
      });
    }
  },
  computed: {
    menuList() {
      return this.$store.state.app.menuList;
    },
    // pageTagsList () {
    //     return this.$store.state.app.pageOpenedList; // 打开的页面的页面对象
    // },
    currentPath() {
      return this.$store.state.app.currentPath; // 当前面包屑数组
    },
    avatorPath() {
      return $utils.data.get("auth", "avatar");
    },
    cachePage() {
      return this.$store.state.app.cachePage;
    },
    lang() {
      return this.$store.state.app.lang;
    },
    menuTheme() {
      return this.$store.state.app.menuTheme;
    },
    mesCount() {
      return this.$store.state.app.messageCount;
    },
    cardLoading() {
      return this.$store.state.app.cardLoading;
    },
    userName() {
      return $utils.data.get("auth", "uname") || "";
    },
    shopId() {
      return (
        this.$store.state.app.shopId || $utils.data.get("app", "shopId") || ""
      );
    },
    shopName() {
      return (
        this.$store.state.app.shopName ||
        $utils.data.get("app", "shopName") ||
        ""
      );
    },
  },
  methods: {
    /* GouserInfo() {
      $utils.url.push({ name: "userInfo_Index" });
    }, */
    async ok() {
      try {
        let res = await $utils.api.load(
          `/admin/system/information/readAll`,
          [],
          "PUT"
        );
        if (res.code == 200) {
          this.$Message.info("已清空");
          this.getMessageNum();
          window.location.reload();
        }
      } catch (error) {
        console.error(error);
      }
    },
    onMessageTo() {
      this.getMessageNum();
      $utils.url.push({
        name: "messageNotification_list",
      });
    },
    async getMessageNum() {
      let res = await $utils.api.load(
        `/admin/system/information/count`,
        {},
        "GET"
      );
      if (res.code == 200) {
        window.localStorage.setItem("messageNum", res.data);
      }
    },
    getLogin() {
      //检测登录状态
      let MaintainerToken = global.$utils.data.get("", "token");

      if (!MaintainerToken) {
        if (window.localStorage.getItem("token") == '{"data":""}') {
          //$utils.url.push({ name: 'login' })
          return false;
        }
      }
      // 检测登录状态
      $utils.api
        .load("authCheck", {}, "post", {
          toast: false,
          toasterror: false,
          loading: false,
          loadingtext: "Loading",
          login: false,
        })
        .then((res) => {
          if (res.code != 200) {
            if (
              window.localStorage.getItem("pcFun") == 2 ||
              window.localStorage.getItem("pcFun") == 5
            ) {
              return;
            } else {
              // 登录
              $utils.url.push({ name: "login" });
              return false;
            }
          }
          if (res.user && res.auths) {
            const last_login_time = $utils.time.format(
              res.user.loginDate || ""
            );
            $utils.data.set("auth", "last_login_time", last_login_time);
            $utils.data.set("auth", "auths", []);
            $utils.data.set("auth", "username", res.user.nickName);
            $utils.data.set("auth", "userName", res.user.userName);
            $utils.data.set("auth", "suid", res.user.userId);
            $utils.data.set("auth", "uid", res.user.userId);
            $utils.data.set("auth", "uname", res.user.nickName);
            $utils.data.set("auth", "isAdmin", res.user.isAdmin);
            $utils.data.set(
              "auth",
              "avatar",
              $utils.image.load(res.user.avatar) ||
                require("@/assets/img/useravatar.jpg")
            );
            $utils.data.set("auth", "auths", res.auths);
            $utils.data.set("auth", "makeMain", res.makeMain);
            $utils.data.set("auth", "deskId", res.user.deskId);
            global.$utils.data.set("auth", "makeMain", res.makeMain);
            // const last_login_time = $utils.time.format(res.data.last_login_time || '')
            // $utils.data.set('auth', 'last_login_time', last_login_time)
            // $utils.data.set('auth', 'auths', [])
            // $utils.data.set('auth', 'username', res.data.username)
            // $utils.data.set('auth', 'suid', res.data.suid)
            // $utils.data.set('auth', 'uid', res.data.uid)
            // $utils.data.set('auth', 'uname', res.data.uname)
            // $utils.data.set('auth', 'avatar', $utils.image.load(res.data.head) || require('@/assets/img/useravatar.jpg'))
            // $utils.data.set('auth', 'auths', res.data.auths)
            // $utils.data.set('auth', 'is_system', res.data.is_admin)
            // $utils.data.set('auth', 'is_admin', res.data.is_admin)
            // $utils.data.set('auth', 'is_all_order', res.data.is_all_order)
            // $utils.data.set('auth', 'shop_id', res.data.shop_id)
            // $utils.data.set('auth', 'shop_name', res.data.shop_name)
            // 强制刷新页面 否则左侧路由无法更新
            this.$store.commit("updateMenulist");
            if (res.user.deskId) {
              this.getDeskInfo(res.user.deskId);
            }
          } else {
            $utils.toast.error(res.message);
          }
        });
    },
    init() {
      let pathArr = $utils.view.setCurrentPath(this, this.$route.name);
      this.$store.commit("updateMenulist");
      if (pathArr.length >= 2) {
        this.$store.commit("addOpenSubmenu", pathArr[1].name);
      }
      let messageCount = 3;
      this.messageCount = messageCount.toString();
      this.$store.commit("setMessageCount", 3);
    },
    toggleClick() {
      this.shrink = !this.shrink;
    },
    backClick() {
      $utils.url.go(-1);
    },
    async getCustomerInfo() {
      // 加载详情数据
      let res = await $utils.api.load(
        `/admin/system/customer/getCustomerInfo`,
        {},
        "GET"
      );
      if (res && res.data) {
        window.localStorage.setItem("customerId", res.data.id);
        window.localStorage.setItem("customerName", res.data.customerName);
        this.customerName = res.data.customerName;
        if (res.data.id === 149) {
          this.schoolId = true;
          this.logo = config.logoSchool;
          this.minlogo = config.minlogoSchool;
        }
        if (res.data.id === 153) {
          this.syfId = true;
        }
      }
    },
    async getDeskInfo(id) {
      if (id == undefined) {
        return;
      } else {
        let res = await $utils.api.load(`/admin/system/desk/${id}`);
        if (res.code === 200) {
          if (res.data) {
            this.deskName = res.data.deskName;
            this.address = res.data.address;
          }
        }
      }
    },
    async getUserCall() {
      // 加载详情数据
      let res = await $utils.api.load(
        `/admin/system/user/getUserInfo`,
        {},
        "GET"
      );
      if (res && res.data) {
        if (res.data.channelIds !== "")
          await this.initChart(res.data.channelIds);
      }
    },
    async initChart(channelId) {
      let res2 = await $utils.api.load(`/admin/system/record/getCalling`, {});
      if (res2 && res2.code === 200 && res2.data) {
        let callVo = res2.data;
        this.$Modal.success({
          closable: true,
          width: "1200px",
          // okButtonProps:{ style: { display: 'none' } },
          // footerHide: true,
          okText: "取消",
          showOk: false,
          render: (h) => {
            return (
              <Calling
                style={{ margin: "0", color: "#19be6b" }}
                deskId={callVo.deskId}
                phone={callVo.callno}
                callId={callVo.id}
              ></Calling>
            );
          },
        });
      }
      // });
      // }
    },
    handleClickUserDropdown(name) {
      if (name === "password") {
        this.$router.push({
          name: "user_up_password",
        });
      } else if (name === "userInfo") {
        console.log(1111111111);
        let isAuthRecord = $utils.data.get("auth", "isAuths");
        $utils.data.set("auth", "isAuthRecord", isAuthRecord);
        $utils.data.set("auth", "isAuths", 14);
        this.$store.commit("updateMenulist");
        $utils.url.push({ name: "userInfo_Index" });
      } else if (name === "logout") {
        // 退出登录
        $utils.api.load("authLogout").then((res) => {
          $utils.data.set("auth", "auths", []);
          window.localStorage.setItem("token", "");
          $utils.data.clear("auth");
          $utils.data.clear("storage");
          this.$store.commit("logout", this);
          this.$router.push({
            name: "login",
          });
        });
      } else if (name === "clearcache") {
        // 清理缓存
        $utils.api.load("siteClearCache").then((res) => {
          $utils.toast.text(res.message);
        });
      } else {
        // 切换商家
        this.handleClickShopDropdown(name);
      }
    },
    handleSubmenuChange(val) {},
    beforePush(name) {
      return true;
    },
    fullscreenChange(isFullScreen) {},
    scrollBarResize() {
      this.$refs.scrollBar &&
        this.$refs.scrollBar.resize &&
        this.$refs.scrollBar.resize();
    },
    handleClickShopDropdown(name) {
      // 切换小区
      let c_id = name;
      let c_name = "";
      for (let index = 0; index < this.shopDrop.length; index++) {
        const element = this.shopDrop[index];
        if (element.value == c_id) {
          c_name = element.name;
        }
      }
      if (c_name) {
        $utils.data.set("app", "shopId", c_id);
        $utils.data.set("app", "shopName", c_name);
        this.$store.commit("setShop", { shopId: c_id, shopName: c_name });
        window.location.reload(true);
      }
    },
    goToIndex() {
      $utils.url.push({ path: "/index" });
    },
  },
  watch: {
    $route(to) {
      console.log(to, 1111111111, 22222);
      if (
        $utils.data.get("auth", "isAuthRecord") &&
        to.name != "userInfo_Index"
      ) {
        let isAuth = $utils.data.get("auth", "isAuthRecord");
        $utils.data.set("auth", "isAuths", isAuth);
        this.$store.commit("updateMenulist");
      }

      this.$store.commit("setCurrentPageName", to.name);
      let pathArr = $utils.view.setCurrentPath(this, to.name);
      if (pathArr.length > 2) {
        this.$store.commit("addOpenSubmenu", pathArr[1].name);
      }
      localStorage.currentPageName = to.name;
    },
    lang() {
      $utils.view.setCurrentPath(this, this.$route.name); // 在切换语言时用于刷新面包屑
    },
    openedSubmenuArr() {
      setTimeout(() => {
        this.scrollBarResize();
      }, 300);
    },
  },
  mounted() {
    this.init();
    window.addEventListener("resize", this.scrollBarResize);
  },
  dispatch() {
    window.removeEventListener("resize", this.scrollBarResize);
  },
};
</script>
<style lang="less">
.lock-screen-back {
  border-radius: 50%;
  z-index: -1;
  box-shadow: 0 0 0 0 #667aa6 inset;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: all 3s;
}

.main {
  position: absolute;
  width: 100%;
  height: 100%;

  .unlock-con {
    width: 0px;
    height: 0px;
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 11000;
  }

  .sidebar-menu-con {
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 21;
    transition: width 0.3s;
  }

  .layout-text {
    display: inline-block;
    white-space: nowrap;
    position: absolute;
  }

  .main-hide-text .layout-text {
    display: none;
  }

  &-content-container {
    position: relative;
  }

  &-header-con {
    box-sizing: border-box;
    position: fixed;
    display: block;
    padding-left: 200px;
    width: 100%;
    height: 100px;
    z-index: 20;
    box-shadow: 0 2px 1px 1px rgba(100, 100, 100, 0.1);
    transition: padding 0.3s;
  }

  &-breadcrumb {
    padding: 8px 15px 0;
  }

  &-menu-left {
    background: #464c5b;
    height: 100%;
  }

  .tags-con {
    height: 40px;
    z-index: -1;
    overflow: hidden;
    background: #f0f0f0;

    .tags-outer-scroll-con {
      position: relative;
      box-sizing: border-box;
      padding-right: 120px;
      width: 100%;
      height: 100%;

      .tags-inner-scroll-body {
        position: absolute;
        padding: 2px 10px;
        overflow: visible;
        white-space: nowrap;
        transition: left 0.3s ease;
      }

      .close-all-tag-con {
        position: absolute;
        right: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 8px;
        text-align: center;
        width: 110px;
        height: 100%;
        background: white;
        box-shadow: -3px 0 15px 3px rgba(0, 0, 0, 0.1);
        z-index: 10;
      }
    }
  }

  &-header {
    height: 60px;
    background: #fff;
    box-shadow: 0 2px 1px 1px rgba(100, 100, 100, 0.1);
    box-shadow: none;
    display: flex;
    align-items: center;
    z-index: 11;

    .navicon-con {
      display: inline-block;
      margin: 0 5px;
    }

    .header-middle-con {
      overflow: hidden;

      .main-breadcrumb {
        padding: 0;
      }
    }

    .header-avator-con {
      // height: 100%;
      width: 380px;
      float: right;

      .message_notification {
        padding-top: 5px;
        height: 60px;
        display: flex;
        align-items: center;
        padding-right: 20px;
        box-sizing: border-box;

        .message_notification_item {
          display: flex;
          align-items: center;
        }

        img {
          width: 30px;
        }
      }

      .broom {
        padding-top: 5px;
        height: 60px;
        display: flex;
        align-items: center;
        margin: 0 10px;
        box-sizing: border-box;
      }

      .switch-theme-con {
        display: inline-block;
        width: 40px;
        height: 100%;
      }

      .message-con {
        display: inline-block;
        width: 30px;
        padding: 18px 0;
        text-align: center;
        cursor: pointer;

        i {
          vertical-align: middle;
        }
      }

      .change-skin {
        font-size: 14px;
        font-weight: 500;
        padding-right: 5px;
      }

      .switch-theme {
        height: 100%;
      }

      .main-user-name1 {
        white-space: nowrap;
        // margin-top: -15px;
        // position: absolute;
        // right: 87px;
        color: #2a75ed;
        font-size: 14px;
        margin-top: 8px;
      }

      .main-user-name3 {
        white-space: nowrap;
        // margin-top: -15px;
        // position: absolute;
        // right: 100px;
        color: #2a75ed;
        font-size: 14px;
        margin-top: 8px;
      }

      .user-dropdown {
        &-menu-con {
          position: absolute;

          right: 0;
          top: -5px;
          // width: 150px;
          height: 100%;

          .main-user-name2 {
            display: inline-block;
            // width: 120px;
            font-size: 14px;
            color: #2a75ed;
            margin-top: 30px;
            word-break: keep-all;
            white-space: nowrap;
            vertical-align: middle;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: right;
            min-width: 100px;
          }
        }

        &-innercon {
          height: 100%;
          padding-right: 14px;
        }
      }

      .full-screen-btn-con {
        display: inline-block;
        width: 30px;
        padding: 18px 0;
        text-align: center;
        cursor: pointer;

        i {
          vertical-align: middle;
        }
      }

      .lock-screen-btn-con {
        display: inline-block;
        width: 30px;
        padding: 18px 0;
        text-align: center;
        cursor: pointer;

        i {
          vertical-align: middle;
        }
      }
    }
  }

  .single-page-con {
    position: absolute;
    top: 100px;
    right: 0;
    bottom: 0;
    overflow: auto;
    background-color: #f5f7fa;
    z-index: 1;
    transition: left 0.3s;
    height: calc(100vh - 110px);

    .single-page {
      margin: 0 10px 10px 10px;
    }
  }

  &-copy {
    text-align: center;
    padding: 10px 0 20px;
    color: #9ea7b4;
  }
}

.taglist-moving-animation-move {
  transition: transform 0.3s;
}

.logo-con {
  padding: 6px;
  padding-bottom: 0;
  // text-align: left;
  display: flex;
  align-items: center;

  .logo {
    max-width: 65%;
    /* 最大宽度为容器的 100% */
    height: auto;
    // margin-top: 10px;
    padding-left: 18px;
  }

  .logo_min {
    width: 44px;
  }

  // img {
  //   height: 44px;
  //   width: auto;
  // }
}

.dropdown-class {
  max-height: 300px;
}

.card-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
